// Author registry. Each article frontmatter references an author by slug.
// Author data drives:
//   - Byline UI on article pages
//   - Person schema JSON-LD for E-E-A-T signals
//   - Author-specific archive pages (future)

export interface Author {
  slug: string;
  name: string;
  title: string;
  bio: string;
  expertise: string[];
  avatar?: string;
  linkedin?: string;
  twitter?: string;
}

// Only add a named author here if they are a real person who has agreed to be
// credited, and every credential below can be verified. Invented bylines or
// credentials hurt trust and are penalised by search engines (E-E-A-T).
const EDITORIAL: Author = {
  slug: "editorial",
  name: "Imports.com.gh Editorial",
  title: "Editorial Team",
  bio: "Guides and cost breakdowns from the Imports.com.gh team on importing vehicles and goods to Ghana. Figures are indicative estimates; always confirm current duty rates and fees with the Ghana Revenue Authority (GRA) or a licensed clearing agent.",
  expertise: ["vehicle imports", "Ghana customs", "shipping"],
};

export const AUTHORS: Record<string, Author> = { editorial: EDITORIAL };

export function getAuthor(slug: string): Author {
  return AUTHORS[slug] ?? EDITORIAL;
}

const SITE = (
  import.meta.env["VITE_SITE_URL"] || "https://imports.com.gh"
).replace(/\/$/, "");

export function personSchema(author: Author) {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    name: author.name,
    jobTitle: author.title,
    description: author.bio,
    knowsAbout: author.expertise,
    url: `${SITE}/insights?author=${author.slug}`,
    ...(author.linkedin || author.twitter
      ? {
          sameAs: [author.linkedin, author.twitter].filter(Boolean) as string[],
        }
      : {}),
    worksFor: {
      "@type": "Organization",
      name: "Imports.com.gh",
      url: SITE,
    },
  };
}
